import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MeterModel } from 'src/app/models/maintenance/meter.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MeterService {

  private readonly _httpClient = inject(HttpClient);

  changeState(meterId: number): Observable<MeterModel> {
    const params = new HttpParams().set('meterId', meterId);
    return this._httpClient.put<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.ChangeStateAsync}`, null,
      { params: params }
    );
  }

  create(meter: MeterModel): Observable<MeterModel> {
    return this._httpClient.post<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.CreateAsync}`,
      meter
    );
  }

  delete(meterId: number): Observable<MeterModel> {
    const params = new HttpParams().set('meterId', meterId);
    return this._httpClient.delete<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.DeleteAsync}`,
      { params: params }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.ExportGeneralConsultation}`,
      filters, {
      params, responseType: 'blob',
    });
  }

  getAllMetersWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetAllMetersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getById(meterId: number): Observable<MeterModel> {
    const params = new HttpParams().set('meterId', meterId);
    return this._httpClient.get<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetByIdAsync}`,
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstMeterByKeys(branchId: number): Observable<MeterModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetFirstMeterByKeysAsync}`,
      { params: params }
    );
  }

  getLastMeterByKeys(branchId: number): Observable<MeterModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetLastMeterByKeysAsync}`,
      { params: params }
    );
  }

  getMeterByKeys(branchId: number, consecutive: number): Observable<MeterModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetMeterByKeysAsync}`,
      { params: params }
    );
  }

  getNextMeterByKeys(branchId: number, consecutive: number): Observable<MeterModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetNextMeterByKeysAsync}`,
      { params: params }
    );
  }

  getPreviousMeterByKeys(branchId: number, consecutive: number): Observable<MeterModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.GetPreviousMeterByKeysAsync}`,
      { params: params }
    );
  }

  update(meter: MeterModel): Observable<MeterModel> {
    return this._httpClient.put<MeterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.meter.UpdateAsync}`,
      meter
    );
  }
}
